import React from 'react';

const FormWrapper = (props) => {
  const {
    children,
    onSubmit,
    submitRef,
    onClick,
    className = '',
    formMethod,
    formName,
  } = props || {};

  return (
    <form
      noValidate={true}
      onSubmit={onSubmit}
      className={className}
      method={formMethod || 'get'}
      name={formName}
    >
      {children}
      <button
        type="submit"
        ref={submitRef}
        className="display-none"
        onClick={onClick}
      />
    </form>
  );
};

export default FormWrapper;

